import noUndefined from "./lib/noUndefined";

const _ActionTypes = Object.freeze({
  ACCEPT_LIABILITY: "ACCEPT_LIABILITY",
  APPLICATIONS_ADMIN: "APPLICATIONS_ADMIN",
  APPLICATIONS_ADMIN_DETAIL: "APPLICATIONS_ADMIN_DETAIL",
  APPLICATIONS_ADMIN_DETAIL_PATCH: "APPLICATIONS_ADMIN_DETAIL_PATCH",
  APPLICATIONS_ADMIN_OPEN_HOUSE: "APPLICATIONS_ADMIN_OPEN_HOUSE",
  APPLICATIONS_ADMIN_OPEN_HOUSE_ADD_SUCCESS: "APPLICATIONS_ADMIN_OPEN_HOUSE_ADD_SUCCESS",
  APPLICATIONS_ADMIN_OPEN_HOUSE_DETAIL: "APPLICATIONS_ADMIN_OPEN_HOUSE_DETAIL",
  APPLICATIONS_ADMIN_OPEN_HOUSE_DETAIL_UPDATE: "APPLICATIONS_ADMIN_OPEN_HOUSE_UPDATE",
  APPLICATIONS_ADMIN_OPEN_HOUSE_DETAIL_UPDATE_SUCCESS:
    "APPLICATIONS_ADMIN_OPEN_HOUSE_UPDATE_SUCCESS",
  APPLICATIONS_ADMIN_OPEN_HOUSE_DETAIL_DELETE: "APPLICATIONS_ADMIN_OPEN_HOUSE_DETAIL_DELETE",
  APPLICATIONS_ADMIN_OPEN_HOUSE_DETAIL_DELETE_SUCCESS:
    "APPLICATIONS_ADMIN_OPEN_HOUSE_DETAIL_DELETE_SUCCESS",
  APPLICATIONS_MEMBER: "APPLICATIONS_MEMBER",
  APPLICATIONS_MEMBER_CHOOSE_PASSWORD_POST: "APPLICATIONS_MEMBER_CHOOSE_PASSWORD_POST",
  APPLICATIONS_MEMBER_CHOOSE_PASSWORD_POST_SUCCESS:
    "APPLICATIONS_MEMBER_CHOOSE_PASSWORD_POST_SUCCESS",
  APPLICATIONS_MEMBER_OPEN_HOUSE: "APPLICATIONS_MEMBER_OPEN_HOUSE",
  APPLICATIONS_MEMBER_OPEN_HOUSE_RSVP: "APPLICATIONS_MEMBER_OPEN_HOUSE_RSVP",
  APPLICATIONS_MEMBER_OPEN_HOUSE_RSVP_DELETE: "APPLICATIONS_MEMBER_OPEN_HOUSE_RSVP_DELETE",
  APPLICATIONS_MEMBER_OPEN_HOUSE_RSVP_DELETE_SUCCESS:
    "APPLICATIONS_MEMBER_OPEN_HOUSE_RSVP_DELETE_SUCCESS",
  APPLICATIONS_MEMBER_OPEN_HOUSE_RSVP_POST: "APPLICATIONS_MEMBER_OPEN_HOUSE_RSVP_POST",
  APPLICATIONS_MEMBER_OPEN_HOUSE_RSVP_POST_SUCCESS:
    "APPLICATIONS_MEMBER_OPEN_HOUSE_RSVP_POST_SUCCESS",
  APPLICATIONS_MEMBER_POST: "APPLICATION_MEMBER_POST",
  APPLICATIONS_MEMBER_POST_SUCCESS: "APPLICATIONS_MEMBER_POST_SUCCESS",
  APPOINTMENT: "APPOINTMENT",
  APPOINTMENTS: "APPOINTMENTS",
  APPOINTMENTS_SETTING: "APPOINTMENTS_SETTING",
  CHANGE_OPTIN: "CHANGE_OPTIN",
  DATES: "DATES",
  DECLINE_LIABILITY: "DECLINE_LIABILITY",
  DELETE_APPOINTMENT: "DELETE_APPOINTMENT",
  DELETE_OPTIN: "DELETE_OPTIN",
  ERROR: "ERROR",
  FINANCE_API_BALANCE: "FINANCE_API_BALANCE",
  FINANCE_API_BALANCE_DETAILS: "FINANCE_API_BALANCE_DETAILS",
  FINANCE_API_MAIN_LEDGER: "FINANCE_API_MAIN_LEDGER",
  FINANCE_API_MAIN_LEDGER_ADJ: "FINANCE_API_MAIN_LEDGER_ADJ",
  FINANCE_API_MAIN_LEDGER_POST_REVENUE: "FINANCE_API_MAIN_LEDGER_POST_REVENUE",
  FINANCE_API_MAIN_LEDGER_REVENUE_CATEGORIES: "FINANCE_API_MAIN_LEDGER_REVENUE_CATEGORIES",
  FINANCE_API_REFUND_REQUESTS: "FINANCE_API_REFUND_REQUESTS",
  GROUP_DETAIL: "GROUP_DETAIL",
  GROUP_MEMBERS: "GROUP_MEMBERS",
  GROUP_MEMBERS_ADMIN: "GROUP_MEMBERS_ADMIN",
  GROUP_MEMBERS_ADMIN_DELETE: "GROUP_MEMBERS_ADMIN_DELETE",
  GROUP_MEMBERS_ADMIN_MODERATE: "GROUP_MEMBERS_ADMIN_MODERATE",
  GROUP_MEMBERS_ADMIN_RESTORE: "GROUP_MEMBERS_ADMIN_RESTORE",
  GROUP_MEMBERS_ADMIN_UNMODERATE: "GROUP_MEMBERS_ADMIN_UNMODERATE",
  GROUP_MEMBER_DELETE: "GROUP_MEMBER_DELETE",
  GROUP_MEMBER_MODERATE: "GROUP_MEMBER_MODERATE",
  GROUP_MEMBER_RESTORE: "GROUP_MEMBER_RESTORE",
  GROUP_MEMBER_UNMODERATE: "GROUP_MEMBER_UNMODERATE",
  INTERVAL: "INTERVAL",
  INTERVALS: "INTERVALS",
  LOADING: "LOADING",
  MEMBERSHIP_CHANGES_ACCOUNT_LIST: "MEMBERSHIP_CHANGES_ACCOUNT_LIST",
  MEMBERSHIP_CHANGES_LIST: "MEMBERSHIP_CHANGES_LIST",
  MEMBERSHIP_CHANGES_LIST_DELETE: "MEMBERSHIP_CHANGES_LIST_DELETE",
  MEMBERSHIP_CHANGES_LIST_DELETE_SUCCESS: "MEMBERSHIP_CHANGES_LIST_DELETE_SUCCESS",
  MEMBERSHIP_CHANGES_LIST_POST: "MEMBERSHIP_CHANGES_LIST_POST",
  MEMBERSHIP_CHANGES_LIST_POST_SUCCESS: "MEMBERSHIP_CHANGES_LIST_POST_SUCCESS",
  MEMBERSHIP_CHANGES_OPTIONS_LIST: "MEMBERSHIP_CHANGES_OPTIONS_LIST",
  MEMBERSHIP_CHANGES_UPLOAD_POST: "MEMBERSHIP_CHANGES_UPLOAD_POST",
  MEMBERSHIP_CHANGES_UPLOAD_POST_SUCCESS: "MEMBERSHIP_CHANGES_UPLOAD_POST_SUCCESS",
  MEMBERSHIP_CHARGES_EXCLUDED_LIST: "MEMBERSHIP_CHARGES_EXCLUDED_LIST",
  MEMBERSHIP_CHARGES_MISMATCH_LIST: "MEMBERSHIP_CHARGES_MISMATCH_LIST",
  MEMBERSHIP_CHARGES_LIST: "MEMBERSHIP_CHARGES_LIST",
  OPTINS: "OPTINS",
  PASS_STATUS_API_DETAIL: "PASS_STATUS_API_DETAIL",
  PATCH_APPOINTMENT: "PATCH_APPOINTMENT",
  PATCH_APPOINTMENTS_SETTING: "PATCH_APPOINTMENTS_SETTING",
  PERSON: "PERSON",
  PERSONAL_ASSISTANTS_API_LIST: "PERSONAL_ASSISTANTS_API_LIST",
  PERSONAL_ASSISTANTS_API_REMOVE: "PERSONAL_ASSISTANTS_API_REMOVE",
  PERSONAL_ASSISTANTS_API_UPDATE: "PERSONAL_ASSISTANTS_API_UPDATE",
  PERSON_APPOINTMENTS: "PERSON_APPOINTMENTS",
  PHOTOS: "PHOTOS",
  PHOTOS_TO_REVIEW: "PHOTOS_TO_REVIEW",
  PHOTO_APPROVE: "PHOTO_APPROVE",
  PHOTO_REQUEST_CHANGE: "PHOTO_REQUEST_CHANGE",
  POST_APPOINTMENT: "POST_APPOINTMENT",
  POST_GROUP_MEMBER: "POST_GROUP_MEMBER",
  POST_OPTINS: "POST_OPTINS",
  POST_PHOTO: "POST_PHOTO",
  POST_RECIPROCITY: "POST_RECIPROCITY",
  POST_SETTINGS: "POST_SETTINGS",
  PUT_APPOINTMENTS_SETTING: "PUT_APPOINTMENTS_SETTING",
  PUT_GROUP_MEMBER: "PUT_GROUP_MEMBER",
  SEARCH_PEOPLE: "SEARCH_PEOPLE",
  SELECT_DATE: "SELECT_DATE",
  SELECT_PERSON: "SELECT_PERSON",
  SETTING: "SETTING",
  SETTINGS: "SETTINGS",
  SEVENROOMS_API_ADMIN_RESERVATIONS: "SEVENROOMS_API_ADMIN_RESERVATIONS",
  SEVENROOMS_API_ADMIN_RESERVATIONS_TODAY: "SEVENROOMS_API_ADMIN_RESERVATIONS_TODAY",
  SEVENROOMS_API_EVENT_BLOCKS: "SEVENROOMS_API_EVENT_BLOCKS",
  SEVENROOMS_API_EVENT_BLOCKS_DETAIL_DELETE: "SEVENROOMS_API_EVENT_BLOCKS_DETAIL_DELETE",
  SEVENROOMS_API_RESERVATIONS: "SEVENROOMS_API_RESERVATIONS",
  SEVENROOMS_API_RESERVATIONS_DELETE: "SEVENROOMS_API_RESERVATIONS_DELETE",
  SEVENROOMS_API_RESERVATIONS_POST: "SEVENROOMS_API_RESERVATIONS_POST",
  SEVENROOMS_API_RESERVATIONS_POST_SUCCESS: "SEVENROOMS_API_RESERVATIONS_POST_SUCCESS",
  SEVENROOMS_API_RESERVATION_REQUESTS: "SEVENROOMS_API_RESERVATION_REQUESTS",
  SEVENROOMS_API_VENUES: "SEVENROOMS_API_VENUES",
  SEVENROOMS_API_VENUE_AVAILABILITY: "SEVENROOMS_API_VENUE_AVAILABILITY",
  SEVENROOMS_ERROR: "SEVENROOMS_ERROR",
  SLOTS: "SLOTS",
  SMS_ADMIN_SEND_SMS: "SMS_ADMIN_SEND_SMS",
  SMS_ADMIN_TEMPLATE_RENDER_SMS: "SMS_ADMIN_TEMPLATE_RENDER_SMS",
  SMS_ADMIN_TEMPLATE_RENDER_SMS_CLEAR: "SMS_ADMIN_TEMPLATE_RENDER_SMS_CLEAR",
  SMS_API_LIST: "SMS_API_LIST",
  SMS_API_LIST_REFRESH: "SMS_API_LIST_REFRESH",
  SMS_API_TEMPLATE_LIST: "SMS_API_TEMPLATE_LIST",
  UNSELECT_PERSON: "UNSELECT_PERSON",
  VERIFY_REQUIRED_API: "VERIFY_REQUIRED_API",
  VERIFY_REQUIRED_API_DETAIL: "VERIFY_REQUIRED_API_DETAIL",
  VOTING_API_RATE: "VOTING_API_RATE",
  VOTING_API_RATE_MY: "VOTING_API_RATE_MY",
  VOTING_API_RATE_OTHERS: "VOTING_API_RATE_OTHERS",
  VOTING_API_UPDATE_APPLICATIONS: "VOTING_API_UPDATE_APPLICATIONS"
});

const ActionTypes = noUndefined(_ActionTypes);

export default ActionTypes;
